"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAndInstallPixels = exports.CreateAndInstallPixels = exports.CreateAndInstallPixelsActionTypes = exports.uninstallPixel = exports.UninstallPixel = exports.UninstallPixelActionTypes = exports.fetchPixels = exports.FetchPixels = exports.FetchPixelsActionTypes = exports.AdsPixelActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _fluxActions = require("flux-actions");

var AdsPixelActionTypes = (0, _namespacedKeyMirror.default)({
  CREATE_AND_INSTALL_PIXELS: null,
  FETCH_PIXELS: null,
  UNINSTALL_PIXEL: null
}, 'ads');
exports.AdsPixelActionTypes = AdsPixelActionTypes;
var FetchPixelsActionTypes = (0, _actions.createRequestTypes)(AdsPixelActionTypes.FETCH_PIXELS);
exports.FetchPixelsActionTypes = FetchPixelsActionTypes;
var FetchPixels = (0, _actions.createRequestActions)(FetchPixelsActionTypes);
exports.FetchPixels = FetchPixels;
var fetchPixels = (0, _fluxActions.createAction)(AdsPixelActionTypes.FETCH_PIXELS);
exports.fetchPixels = fetchPixels;
var UninstallPixelActionTypes = (0, _actions.createRequestTypes)(AdsPixelActionTypes.UNINSTALL_PIXEL);
exports.UninstallPixelActionTypes = UninstallPixelActionTypes;
var UninstallPixel = (0, _actions.createRequestActions)(UninstallPixelActionTypes);
exports.UninstallPixel = UninstallPixel;
var uninstallPixel = (0, _fluxActions.createAction)(AdsPixelActionTypes.UNINSTALL_PIXEL, (0, _actions.mapPayloadTo)('data'));
exports.uninstallPixel = uninstallPixel;
var CreateAndInstallPixelsActionTypes = (0, _actions.createRequestTypes)(AdsPixelActionTypes.CREATE_AND_INSTALL_PIXELS);
exports.CreateAndInstallPixelsActionTypes = CreateAndInstallPixelsActionTypes;
var CreateAndInstallPixels = (0, _actions.createRequestActions)(CreateAndInstallPixelsActionTypes);
exports.CreateAndInstallPixels = CreateAndInstallPixels;
var createAndInstallPixels = (0, _fluxActions.createAction)(AdsPixelActionTypes.CREATE_AND_INSTALL_PIXELS, (0, _actions.mapPayloadTo)('data'));
exports.createAndInstallPixels = createAndInstallPixels;